import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { CompletedTopicsPage } from '../up-next-page/types';

export const PAGE_SIZE = 20;

const initialState = {
  topics: [] as CompletedTopicsPage['data'],
  total: 0,
  page: 1,
  search: '',
  isLoading: true,
  error: false,
  requestId: null as string | null
};

export const slice = createSlice({
  name: 'completedTopics',
  initialState,
  reducers: {
    startLoading(
      state,
      action: PayloadAction<{ page: number; search: string; requestId: string }>
    ) {
      Object.assign(state, action.payload);
      state.isLoading = true;
      state.error = false;
      state.topics = [];
      state.total = 0;
    },
    fetchSuccess(state, action: PayloadAction<{ requestId: string; result: CompletedTopicsPage }>) {
      if (state.requestId !== action.payload.requestId) return;
      state.topics = action.payload.result.data;
      state.total = action.payload.result.pagination.total;
      state.isLoading = false;
      state.requestId = null;
    },
    hasError(state, action: PayloadAction<string>) {
      if (state.requestId !== action.payload) return;
      state.error = true;
      state.isLoading = false;
      state.requestId = null;
    },
    reset: () => initialState
  }
});

export default slice.reducer;
